<ng-template #instructionsModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" [id]="'modalTitleId' + examId"
            [attr.aria-label]="examName + ' ' + language.instructions">{{language.instructions}}</h4>
        <ng-container *ngIf="viewMode">
            <button type="button" class="close" (click)="modal.dismiss('Close')" aria-label="Close instructions dialog">
                <span aria-hidden="true">&times;</span>
            </button>
        </ng-container>
    </div>
    <div class="modal-body p-0">
        <div class="card p-2">
            <div class="card-body text-center p-2">
                <div class="accordion" [id]="'instructionaccordion' + examId">

                    <!-- WebTest Instructions -->
                    <div *ngIf="webtestHTML" class="card">
                        <div class="card-header" [id]="'webtest' + examId">
                            <h2 class="mb-0">
                                <button class="btn w-100 text-center no-hover" type="button" data-toggle="collapse"
                                    [attr.data-target]="getHTMLIDRef('webtest', examId)"
                                    [attr.aria-expanded]="webtestHTML ? 'true' : 'false'"
                                    [attr.aria-controls]="'collapsewebtest' + examId">
                                    <span class="text-white"><b>WEBTEST {{language.webtestInstruction}}</b></span>
                                </button>
                            </h2>
                        </div>
                        <div [id]="'collapsewebtest' + examId" class="collapse"
                            [ngClass]="{'show': webtestHTML, 'hide': !webtestHTML}"
                            [attr.aria-labelledby]="getHTMLIDAria('webtest', examId)"
                            [attr.data-parent]="getHTMLIDParent(examId)">
                            <div tabindex="0" class="card-body instruct" [innerHTML]="this.webtestHTML">
                            </div>
                        </div>
                    </div>

                    <!-- Company Instructions -->
                    <div *ngIf="companyHTML" class="card">
                        <div class="card-header" [id]="'company' + examId">
                            <h2 class="mb-0">
                                <button class="btn w-100 text-center no-hover" type="button" data-toggle="collapse"
                                    [attr.data-target]="getHTMLIDRef('company', examId)"
                                    [attr.aria-expanded]="!webtestHTML && companyHTML ? 'true' : 'false'"
                                    [attr.aria-controls]="'collapsecompany' + examId">
                                    <span class="text-white"><b>{{company | uppercase}} {{language.instructions | uppercase}} </b></span>
                                </button>
                            </h2>
                        </div>
                        <div [id]="'collapsecompany' + examId" class="collapse"
                            [ngClass]="{'show': !webtestHTML && companyHTML, 'hide': !(!webtestHTML && companyHTML)}"
                            [attr.aria-labelledby]="getHTMLIDAria('company', examId)"
                            [attr.data-parent]="getHTMLIDParent(examId)">
                            <div tabindex="0" class="card-body instruct" [innerHTML]="this.companyHTML">
                            </div>
                        </div>
                    </div>

                    <!-- Exam Instructions -->
                    <div *ngIf="examHTML" class="card">
                        <div class="card-header" [id]="'exam' + examId">
                            <h2 class="mb-0">
                                <button class="btn w-100 text-center no-hover" type="button" data-toggle="collapse"
                                    [attr.data-target]="getHTMLIDRef('exam', examId)"
                                    [attr.aria-expanded]="!webtestHTML && !companyHTML && examHTML ? 'true' : 'false'"
                                    [attr.aria-controls]="'collapseexam' + examId">
                                    <span class="text-white"><b>{{examName | uppercase}} {{language.instructions | uppercase}} </b></span>
                                </button>
                            </h2>
                        </div>
                        <div [id]="'collapseexam' + examId" class="collapse"
                            [ngClass]="{'show': !webtestHTML && !companyHTML && examHTML, 'hide': !(!webtestHTML && !companyHTML && examHTML)}"
                            [attr.aria-labelledby]="getHTMLIDAria('exam', examId)"
                            [attr.data-parent]="getHTMLIDParent(examId)">
                            <div tabindex="0" class="card-body instruct" [innerHTML]="this.examHTML">
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!viewMode">
        <div class="row m-2">
            <div class="col-md-4"></div>
            <div class="modal-footer col-md-4 p-0">
                <span>
                    <input autofocus class="mr-2" type="checkbox" id="confirmation"
                        (change)="confirmationchecked($event)" aria-labelledby="agreeText">
                    <label for="confirmation" id="agreeText"><b>{{language.agreeToInstructions}}</b></label>
                </span>
                <input [disabled]="!confirmed" class="form-control btn btn-success" type="button"
                    (click)="modal.close(); gotoexam(true)" [value]="language.startExam" [attr.aria-disabled]="!confirmed" />
                <input class="form-control btn btn-danger" type="button" id="clear-options" (click)="modal.dismiss(); resumeinterval()"
                [value]="language.cancel" />
            </div>
        </div>
    </ng-container>
</ng-template>